import { KeyboardArrowDown } from "@mui/icons-material"
import { FormControl, MenuItem, Select, Box } from "@mui/material"
import { cores } from "./optionsCoresPadrao"

const OneSelectCor = ({ name, options = cores, defaultValue, ...rest }) => {
    return (
        <Box>
            <FormControl fullWidth>
                <Select
                    name={name}
                    sx={{
                        // border: '1px solid yellow',
                        background: 'white',
                        boxShadow: 'none',
                        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                        fontWeight: 400,
                        fontSize: '14px',
                        color: '#fff',
                        width: '100%',
                        height: '30px',
                        padding: '0 3px',
                        '& .MuiSelect-icon': {
                            color: '#929292'
                        }
                    }}
                    inputProps={{
                        sx: { padding: '0 5px' }
                    }}
                    IconComponent={KeyboardArrowDown}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: {
                            sx: {
                                border: '1px solid #8a05be',
                                // width: '90%',
                                maxWidth: '500px',
                                // height: 'calc(100% - 116px)',
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center'
                            }
                        },
                        sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                    }}
                    defaultValue={defaultValue || ""}
                    {...rest}
                >
                    <MenuItem key={`menu_cor_vazio`} value="">
                            Nenhuma opção
                    </MenuItem>
                    {options.map((option, i) => (
                        <MenuItem key={`menu_cor_${i}`} value={option?.value}>
                            <div style={{
                                backgroundColor: option.color || "",
                                color: option.color ? '#fff' : '#000000',
                                width: '100%',
                                height: '100%',
                                borderRadius: '5px'
                            }}>
                                <span style={{ color: "rgba(0,0,0,0)" }}>xxxxxxxxxxxxxx</span>
                            </div>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}

export default OneSelectCor
